<template>
  <div class="frmlogin">

    <form @submit.prevent="handleLoginSubmit" class="form-signin shadow p-3 mb-5 bg-white rounded">

    <h1 class="h3 mb-3 fw-normal">Please sign in</h1>

    <div class="input-wrapper1">
     <input type="email" v-model="email" class="frmcontrolnoicon frmcontrol focus-ring"  placeholder="name@example.com" required />
    </div>

    <div class="mt-3">
     <input :type="fieldType" class="frmcontrol focus-ring" v-model="password" placeholder="Password" required/>
     <i class="fa-solid fa-eye" id="eye" @click="obfuscateToggle"></i> 
    </div>


    <button class="btn btn-primary w-100 py-2" type="submit">Sign in <font-awesome-icon icon="fa-solid fa-user" class="fonttxt"/></button>

    <p class="forgot-password text-right">
      <router-link to="forgotpassword"><span class="txtforgetpwd">Forgot Password?</span> </router-link>
    </p>
    
  </form>

  <!-- <VideoPlaryer /> -->
 
</div>
</template>

<script>
import axios from 'axios';
import { useToast } from "vue-toastification";

// import { VmButton, VmContainer } from 'vue3-material';


  export default {
    name: "LoginView",
    components: {

      // VmButton,
      //   VmContainer,
    },
    // props: ['user'],
    data() {
      return {
        email: '',
        password: '',
        passwordVisible: false,
        fieldType: 'text',
        fieldTypeConfirm: 'text'
      }
    },
    methods: {
      async handleLoginSubmit() {
        try {
         const response = await axios.post('login/', {
            email: this.email,
            password: this.password,

            
         });
         console.log(response.data);
         localStorage.setItem('token', response.data.access_token);      
         localStorage.setItem('refresh', response.data.refresh_token);
         this.$store.dispatch('user', response.data.user);
         window.location.replace('/');
        } catch (e) {
          e = "Invalid username or password. Please check and try again!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
          });
        }
      },
      obfuscateToggle() {
          this.fieldType = this.fieldType == "text" ? "password" : "text"
       },
      },
    mounted(){
      this.fieldType = this.type;
    },
    watch:{
      type(val){
          this.fieldType = val;
    }
  }
}
</script>

<style scoped>
  .form-signin {
    width: auto;
    max-width: 330px;
    padding: 15px;
    margin: auto;
    margin-top: 50px;
  }
  
  .form-signin .checkbox {
    font-weight: 400;
  }
  
  .form-signin .form-floating:focus-within {
    z-index: 2;
  }
  
  .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .fonttxt {
    color: white;
    font-size: 30px;
    padding-left: 40px;
  }
  .input-wrapper {
        display:inline-block;
        position: relative;
        width: 100%;
    }
    .input-wrapper:after {
        font-family: 'FontAwesome';
        content: '\f084';
        position: absolute;
        color: grey;
        right: 6px;
        font-size: 18px;
    }

    .frmcontrol {
      width: 100%;
      height: 40px;
      margin-bottom: 20px;
      padding-inline-start: 15px;

    }
    .fa-eye{
      position: relative;
      top: -50px;
      right: -270px;
      cursor: pointer;
      color: blue;
    }
    .frmcontrolnoicon {
      width: 100%;
      border-radius: 5px;
      height: 40px;
      margin-bottom: 20px;
      padding-inline-start: 15px;
    }

    .input-wrapper1 {
        display:inline-block;
        position: relative;
        width: 100%;
    }
    .input-wrapper1:after {
        font-family: 'FontAwesome';
        content: '\f0e0';
        position: absolute;
        color: grey;
        right: 6px;
        font-size: 18px;
    }
  .txtforgetpwd {
    color: blue;
  }
</style>